import React from 'react';
import Card from '../../../../muiComponents/Card';
import {
    LinearProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
} from '@mui/material';
import { useChannelManagers } from '../../../contextsProperty/ContextChannelManagers';
import StatusCell from '../../../../Table/StatusCell';
import {
    headerColumnTypes,
    ITableHeaderColumn,
    sortDirections,
} from '../../../../types/lists/listTypes';
import TableHeader from '../../../../Table/TableHeader';
import '../../../../stylesheets/stylesComponents/table.scss';
import useTranslate from '../../../../customHooks/useTranslate';

const listColumns: ITableHeaderColumn[] = [
    {
        id: 'ChannelManagerStatus/ChannelManagerStatusType/LocalizedCaption',
        labelText: 'status',
        titleText: 'status',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey:
                'ChannelManagerStatus/ChannelManagerStatusType/LocalizedCaption',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'Name',
        labelText: 'name',
        titleText: 'name',
        columnType: headerColumnTypes.SORTABLE,
        sortableProps: {
            sortKey: 'Name',
            defaultSortDir: sortDirections.ASC,
        },
    },
    {
        id: 'ExternalIntegrationType/LocalizedCaption',
        labelText: 'type',
        titleText: 'type',
    },
];

const ChannelManagersList = () => {
    const translate = useTranslate();
    const { items, sortedBy, sortDir, sortByField, isLoading, handleScroll } =
        useChannelManagers();

    return (
        <Card className={` flex-column flex-grow min-height-0 `}>
            <TableContainer
                className=' flex-grow min-height-0 overflow-auto'
                onScroll={handleScroll}
            >
                <Table stickyHeader size='small'>
                    <TableHeader
                        headerColumns={listColumns}
                        sortedBy={sortedBy}
                        sortDir={sortDir}
                        sortByField={sortByField}
                        isLoading={isLoading}
                        selectable={false}
                    />
                    <TableBody>
                        {items.map(item => (
                            <TableRow key={item.Id}>
                                <TableCell>
                                    <StatusCell
                                        text={item.Status}
                                        color={item.StatusColor}
                                    />
                                </TableCell>
                                <TableCell>{item.Name}</TableCell>
                                <TableCell>
                                    {item.ExternalIntegrationType}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                    {(items.length === 0 || isLoading) && (
                        <caption className='no-results'>
                            {isLoading && <LinearProgress />}
                            {items.length === 0 &&
                                !isLoading &&
                                translate('no_results')}
                        </caption>
                    )}
                </Table>
            </TableContainer>
        </Card>
    );
};

export default ChannelManagersList;
